import { ComunidadAdminTab } from "../psychologist/tabs";

export const ComunidadAdminPage = () => {
  return <ComunidadAdminTab />;
};
